import { Pipe, PipeTransform } from '@angular/core';
interface Options {
  matchKey: string;
  showKey: string;
  isGroup?: boolean;
}
@Pipe({ name: 'commonDisplayBinder' })
export class CommonDisplayBinderPipe implements PipeTransform {
  transform(commonCode: string, list: any[], options: Options): string {
    if (!commonCode || !Array.isArray(list) || list.length === 0) {
      return '';
    }
    let country: any;
    if (options?.isGroup) {
      country = list.flatMap(group => group.names).find(c => c[options.matchKey] === commonCode);
    } else {
      country = list.find(c => c[options.matchKey] === commonCode);
    }
    return country ? country[options.showKey] : '';
  }
}
